import React, { useState, useEffect } from 'react';
import ProductList from '../components/ProductList';
import { useSearchParams } from 'react-router-dom';

const Products: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState<'products' | 'prototypes'>(
    tabFromUrl === 'prototypes' ? 'prototypes' : 'products'
  );

  useEffect(() => {
    // URL parametresi değiştiğinde aktif sekmeyi güncelle
    if (tabFromUrl === 'prototypes') {
      setActiveTab('prototypes');
    } else if (tabFromUrl === 'products') {
      setActiveTab('products');
    }
  }, [tabFromUrl]);

  const handleTabChange = (tab: 'products' | 'prototypes') => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-gray-800">Ürün Kartları</h1>
      </div>

      {/* Sekmeler */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => handleTabChange('products')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'products'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Kartlar
          </button>
          <button
            onClick={() => handleTabChange('prototypes')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'prototypes'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Tasarımlar
          </button>
        </nav>
      </div>

      {/* İçerik */}
      <ProductList showPrototypes={activeTab === 'prototypes'} />
    </div>
  );
};

export default Products;